
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { setDiyOrderTemplate } from '@/api/statistics';
import draggable from 'vuedraggable';

@Component({
  name: 'StatisticsSreportTemplate',
  components: {
    draggable
  }
})
export default class extends Vue {
  private formTemplate: any = {}
  private templateEdit: boolean = false;
  private reportType: any = '';
  private isShowTime: any = true;
  private loading: any = false;
  private reportTypeOptions: any = [
    {
      value: '11',
      label: '订单维度'
    },
    {
      value: '12',
      label: '设备维度'
    },
    {
      value: '17',
      label: '任务维度'
    }
  ];
  private timeItemOptions: any = [
    {
      id: '1',
      label: '订单创建时间',
      value: 'order_add_time',
      task_type: 0,
      type: 2
    },
    {
      id: '2',
      label: '订单查看时间',
      value: 'order_view_time',
      task_type: 0,
      type: 2
    },
    {
      id: '3',
      label: '订单处理时间',
      value: 'order_deal_time',
      task_type: 0,
      type: 2
    },
    {
      id: '4',
      label: '任务查看时间',
      value: 'order_task_view_time',
      task_type: 0,
      type: 2
    },
    {
      id: '5',
      label: '任务处理时间',
      value: 'order_task_deal_time',
      task_type: 0,
      type: 2
    },
    {
      id: '6',
      label: '上门预约时间',
      value: 'order_task_visit_time',
      task_type: 2,
      type: 2
    },
    {
      id: '7',
      label: '上门签到时间',
      value: 'order_task_sign_time',
      task_type: 2,
      type: 2
    },
    {
      id: '8',
      label: '报修方确认寄出时间',
      value: 'order_task_send_off_time',
      task_type: 3,
      type: 2
    },
    {
      id: '9',
      label: '服务方确认收货时间',
      value: 'order_task_send_receive_time',
      task_type: 3,
      type: 2
    },
    {
      id: '10',
      label: '任务完成时间',
      value: 'order_task_finish_time',
      task_type: 0,
      type: 2
    },
    {
      id: '11',
      label: '生成电子工单时间',
      value: 'order_electronic_time',
      task_type: 0,
      type: 2
    },
    {
      id: '12',
      label: '订单完成时间',
      value: 'order_finish_time',
      task_type: 0,
      type: 2
    }
  ];
  private parseTimeOptions: any = [
    {
      value: '1',
      label: '暂停时间'
    }
  ];
  private tableData: any = [
    {
      isFirst: 1,
      name: '响应时长',
      startTime: this.timeItemOptions[0],
      endTime: this.timeItemOptions[1],
      parseTime: '',
      timeItemOptions: this.timeItemOptions,
      timeItemOptions2: this.timeItemOptions.slice(1)
    },
    {
      isFirst: 1,
      name: '维修时长',
      startTime: this.timeItemOptions[2],
      endTime: this.timeItemOptions[9],
      parseTime: '',
      timeItemOptions: this.timeItemOptions.slice(2),
      timeItemOptions2: this.timeItemOptions.slice(9)
    },
    {
      isFirst: 1,
      name: '修复时长',
      startTime: this.timeItemOptions[0],
      endTime: this.timeItemOptions[9],
      parseTime: '',
      timeItemOptions: this.timeItemOptions,
      timeItemOptions2: this.timeItemOptions.slice(9)
    }
  ];
  private data1: any = [
    {
      name: '订单号',
      value: 'order_num',
      type: '1'
    },
    {
      name: '工单号',
      value: 'work_order_num',
      type: '1'
    },

    {
      name: '申请人',
      value: 'create_user_name',
      type: '1'
    },
    {
      name: '报修部门',
      value: 'customer_dept',
      type: '1'
    },
    {
      name: '报修部门编号',
      value: 'customer_dept_code',
      type: '1'
    },
    {
      name: '报修部门(含上下级)',
      value: 'more_customer_dept_names',
      type: '1'
    },
    {
      name: '报修公司',
      value: 'create_company_name',
      type: '1'
    },
    {
      name: '客户',
      value: 'customer_company_name',
      type: '1'
    },
    {
      name: '客户(含上下级)',
      value: 'parent_customer_company_name',
      type: '1'
    },
    {
      name: '联系人',
      value: 'name',
      type: '1'
    },
    {
      name: '手机号',
      value: 'mobile',
      type: '1'
    },
    {
      name: '联系电话',
      value: 'phone_num',
      type: '1'
    },
    {
      name: '地址',
      value: 'address',
      type: '1'
    },
    {
      name: '任务描述',
      value: 'trouble_describle',
      type: '1'
    },
    {
      name: '服务部门',
      value: 'servicer_dept',
      type: '1'
    },
    {
      name: '报修sn号',
      value: 'order_device_sn',
      type: '1'
    }, {
      name: '自定义字段1',
      value: 'diy_one_content',
      type: '1'
    }, {
      name: '自定义字段2',
      value: 'diy_two_content',
      type: '1'
    }
  ];

  private data2: any = [
    {
      name: '服务方',
      value: 'servicer_company',
      type: '1'
    },
    {
      name: '订单创建时间',
      value: 'add_time',
      type: '1'
    },
    {
      name: '订单查看时间',
      value: 'view_time',
      type: '1'
    },
    {
      name: '订单处理时间',
      value: 'deal_time',
      type: '1'
    },
    {
      name: '订单完成时间',
      value: 'finish_time',
      type: '1'
    },
    {
      name: '维修单状态',
      value: 'order_service_state_name',
      type: '1'
    },

    {
      name: '订单关闭时间',
      value: 'close_time',
      type: '1'
    },
    {
      name: '预约时间',
      value: 'appointment_time',
      type: '1'
    },
    {
      name: '订单类型',
      value: 'order_type',
      type: '1'
    },
    // {
    //   name: '订单视频',
    //   value: 'rtc_video',
    //   type: '1'
    // },
    {
      name: '报修方/公司、部门评分',
      value: 'repair_dept_com_evaluate_score',
      type: '1'
    },
    {
      name: '报修方/公司、部门评价内容',
      value: 'repair_dept_com_evaluate_detail',
      type: '1'
    },
    {
      name: '服务方/公司、部门评分',
      value: 'service_dept_com_evaluate_score',
      type: '1'
    },
    {
      name: '服务方/公司、部门评价内容',
      value: 'service_dept_com_evaluate_detail',
      type: '1'
    },
    {
      name: '最终/公司、部门评分',
      value: 'final_dept_com_evaluate_score',
      type: '1'
    },
    {
      name: '最终/公司、部门评价内容',
      value: 'final_dept_com_evaluate_detail',
      type: '1'
    },
    {
      name: '报修方/处理人评分',
      value: 'task_evaluate_score',
      type: '1'
    },
    {
      name: '报修方/评价内容',
      value: 'task_evaluate_detail',
      type: '1'
    },
    {
      name: '服务方/处理人评分',
      value: 'task_service_evaluate_score',
      type: '1'
    },
    {
      name: '服务方/评价内容',
      value: 'task_service_evaluate_detail',
      type: '1'
    },
    {
      name: '最终/处理人评分',
      value: 'task_final_evaluate_score',
      type: '1'
    },
    {
      name: '最终/评价内容',
      value: 'task_final_evaluate_detail',
      type: '1'
    },
    {
      name: '是否原厂保修',
      value: 'order_warranty',
      type: '1'
    }
  ];

  private data3: any = [
    {
      name: '任务编号',
      value: 'task_num',
      type: '1'
    },
    {
      name: '派单人',
      value: 'task_assign_user_name',
      type: '1'
    },
    {
      name: '处理人',
      value: 'task_user_name',
      type: '1'
    },
    {
      name: '任务类型',
      value: 'task_deal_type',
      type: '1'
    },
    {
      name: '任务状态',
      value: 'task_state',
      type: '1'
    },
    {
      name: '任务指派时间',
      value: 'task_assign_time',
      type: '1'
    },
    {
      name: '任务查看时间',
      value: 'task_view_time',
      type: '1'
    },
    {
      name: '任务处理时间',
      value: 'task_deal_time',
      type: '1'
    },
    {
      name: '任务完成时间',
      value: 'task_finish_time',
      type: '1'
    },
    {
      name: '任务上报时间',
      value: 'task_appear_time',
      type: '1'
    },
    {
      name: '任务关闭时间',
      value: 'task_close_time',
      type: '1'
    },
    {
      name: '维修小结',
      value: 'task_fix_summary',
      type: '1'
    },
    {
      name: '任务暂停时长',
      value: 'task_suspend_time',
      type: '1'
    },

    {
      name: '任务暂停备注',
      value: 'task_suspend_remark',
      type: '1'
    },
    {
      name: '任务部门',
      value: 'task_dept_name',
      type: '1'
    }
  ];

  private data4: any = [
    {
      name: '上门预约时间',
      value: 'task_visit_time',
      type: '1'
    },
    {
      name: '签到时间',
      value: 'task_checkin_time',
      type: '1'
    },
    {
      name: '签到地点',
      value: 'checkin_addr',
      type: '1'
    },
    {
      name: '完成地点',
      value: 'finish_addr',
      type: '1'
    }
  ];
  private data5: any = [
    {
      name: '报修方寄出时间',
      value: 'task_send_off_time',
      type: '1'
    },
    {
      name: '服务方收货时间',
      value: 'task_send_receive_time',
      type: '1'
    }
  ];
  private data6: any = [
    {
      name: '故障现象',
      value: 'p_fault_phenomenon_name',
      type: '1'
    },
    {
      name: '故障类型',
      value: 'p_fault_type_name',
      type: '1'
    },
    {
      name: '产品品牌',
      value: 'product_brand',
      type: '1'
    },
    {
      name: '产品类型',
      value: 'product_product',
      type: '1'
    },
    {
      name: '产品型号',
      value: 'product_model',
      type: '1'
    },
    {
      name: '产品数量',
      value: 'product_amount',
      type: '1'
    },
    {
      name: '自定义标签',
      value: 'tags_name',
      type: '1'
    },
    {
      name: '备注',
      value: 'all_remark',
      type: '1'
    },
    {
      name: '催单次数',
      value: 'push_reminder_amount',
      type: '1'
    },
    {
      name: '总费用',
      value: 'total_price',
      type: '1'
    },
    {
      name: '备件总费用',
      value: 'parts_amount',
      type: '1'
    },
    {
      name: '其他总费用',
      value: 'price_amount',
      type: '1'
    },
    {
      name: '其他费用明细',
      value: 'price_amount_detail',
      type: '1'
    },
    {
      name: '实际收费',
      value: 'real_price',
      type: '1'
    },
    {
      name: '结算费用',
      value: 'order_service_settle',
      type: '1',
      class: 'other'
    },
    {
      name: '工时明细',
      value: 'work_time_detail',
      type: '1'
    },
    {
      name: '订单状态',
      value: 'order_service_state',
      type: '1'
    },
    {
      name: '订单关闭原因',
      value: 'order_close_remark',
      type: '1'
    },
    {
      name: '订单拒绝验收',
      value: 'order_refuse_complete',
      type: '1'
    },
    {
      name: '回访信息',
      value: 'return_visit',
      type: '1'
    },
    {
      name: '订单投诉',
      value: 'bbs_complaint',
      type: '1'
    },
    {
      name: '订单留言',
      value: 'bbs_ordinary',
      type: '1'
    },
    {
      name: '正常完成任务数',
      value: 'normal_task_count',
      type: '1'
    },
    {
      name: '订单超时',
      value: 'order_timeout',
      type: '1'
    },
    {
      name: '订单加急',
      value: 'expedited',
      type: '1'
    }
  ];

  private data7: any = [
    {
      name: '巡检事件',
      value: 'check_event',
      type: '1'
    },
    {
      name: '检查项',
      value: 'event_list',
      type: '1'
    },
    {
      name: '计划名称',
      value: 'project_name',
      type: '1'
    },
    {
      name: '计划开始时间',
      value: 'project_start_time',
      type: '1'
    },
    {
      name: '计划结束时间',
      value: 'project_end_time',
      type: '1'
    },
    {
      name: '提前生成订单时间',
      value: 'ahead_inform_time',
      type: '1'
    },
    {
      name: '执行规则',
      value: 'implement_project',
      type: '1'
    },
    {
      name: '重复规则',
      value: 'repeat_type',
      type: '1'
    }
  ];
  private data8: any = [
    {
      name: '设备名称',
      value: 'device_name',
      type: '1'
    },
    {
      name: '设备编号',
      value: 'device_number',
      type: '1'
    },
    {
      name: '设备SN号',
      value: 'device_sn',
      type: '1'
    },
    {
      name: '设备品牌',
      value: 'device_brand',
      type: '1'
    },
    {
      name: '设备类型',
      value: 'device_product',
      type: '1'
    },
    {
      name: '设备型号',
      value: 'device_model',
      type: '1'
    },
    {
      name: '设备购买时间',
      value: 'device_buy_time',
      type: '1'
    },
    {
      name: '设备描述',
      value: 'device_describe',
      type: '1'
    },
    {
      name: '设备地址',
      value: 'device_address',
      type: '1'
    },
    {
      name: '设备厂商名称',
      value: 'manufacturer_name',
      type: '1'
    },
    {
      name: '设备厂商电话',
      value: 'manufacturer_phone',
      type: '1'
    },
    {
      name: '备件名称',
      value: 'parts_name',
      type: '1'
    },
    {
      name: '备件型号',
      value: 'parts_model_name',
      type: '1'
    },
    {
      name: '备件编号',
      value: 'parts_serial_number',
      type: '1'
    },
    {
      name: '备件规格',
      value: 'parts_specification',
      type: '1'
    },
    {
      name: '备件数量',
      value: 'parts_amount_count',
      type: '1'
    },
    {
      name: '备件公司成本价',
      value: 'parts_company_price',
      type: '1'
    },
    {
      name: '备件个人成本价',
      value: 'parts_person_price',
      type: '1'
    },
    {
      name: '备件单价',
      value: 'parts_unit_price',
      type: '1'
    }
  ];
  private data9: any = [{
    name: '安装订单来源',
    value: 'install_source_name',
    type: '1'
  }, {
    name: '安装原始单号',
    value: 'order_original_num',
    type: '1'
  }, {
    name: '安装预约时间',
    value: 'original_appointment_time',
    type: '1'
  }]

  // 安装交付

  private checkedSelectedAll: any = false;
  private tableResult: any = [];

  private reportTableSelet1: any = [];
  private reportTableSelet2: any = [];
  private reportTableSelet3: any = [];
  private reportTableSelet4: any = [];
  private reportTableSelet5: any = [];
  private reportTableSelet6: any = [];
  private reportTableSelet7: any = [];
  private reportTableSelet8: any = [];
  private reportTableSelet9: any = [];

  private activeName: any = 'first';
  private selectStartTime(val: any) {
    let arr = this.timeItemOptions.slice(parseInt(val.startTime.id));
    if (val.startTime.task_type !== 0) {
      arr = arr.filter((item: any) => {
        return (
          item.task_type === 0 || val.startTime.task_type === item.task_type
        );
      });
    }
    val.endTime = '';
    val.timeItemOptions2 = arr;
  }

  private deleteItemHandle(val: any) {
    let _index = this.tableData.indexOf(val);
    if (_index !== -1) {
      this.tableData.splice(this.tableData.indexOf(val), 1);
    }
  }
  private addItemHandle() {
    if (this.tableData.length >= 5) {
      this.$confirm('最多可以添加五个自定义时间报表项', '', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'warning'
      }).then(() => {});
    } else {
      this.tableData.push({
        isFirst: 1,
        name: '',
        startTime: '',
        endTime: '',
        parseTime: '',
        timeItemOptions: this.timeItemOptions,
        timeItemOptions2: []
      });
    }
  }
  private handleSelectionChange1(val: any) {
    this.reportTableSelet1 = val;
  }
  private handleSelectionChange2(val: any) {
    this.reportTableSelet2 = val;
  }
  private handleSelectionChange3(val: any) {
    this.reportTableSelet3 = val;
  }
  private handleSelectionChange4(val: any) {
    this.reportTableSelet4 = val;
  }
  private handleSelectionChange5(val: any) {
    this.reportTableSelet5 = val;
  }
  private handleSelectionChange6(val: any) {
    this.reportTableSelet6 = val;
  }
  private handleSelectionChange7(val: any) {
    this.reportTableSelet7 = val;
  }
  private handleSelectionChange8(val: any) {
    this.reportTableSelet8 = val;
  }
  private handleSelectionChange9(val: any) {
    this.reportTableSelet9 = val;
  }
  private isNewModel = false;
  // private createModel() {
  //   if (!this.reportType) {
  //     this.showErrorMsg('请选择报表类型');
  //     return;
  //   }
  //   switch (parseInt(this.reportType)) {
  //     case 11:
  //       this.activeName = 'first';
  //       this.isShowTime = true;
  //       break;
  //     case 12:
  //       this.activeName = 'second';
  //       this.isShowTime = false;
  //       break;
  //     case 17:
  //       this.activeName = 'first';
  //       this.isShowTime = true;
  //       break;
  //   }
  //   this.reportTableSelet1.push(this.data1[0]);
  //   this.templateEdit = true;
  // }
  // private nextStep() {
  //   if (this.activeName === 'first') {
  //     this.activeName = 'second';
  //     this.setSelect1(this.reportTableSelet1);
  //     this.setSelect2(this.reportTableSelet2);
  //     this.setSelect3(this.reportTableSelet3);
  //     this.setSelect4(this.reportTableSelet4);
  //     this.setSelect5(this.reportTableSelet5);
  //     this.setSelect6(this.reportTableSelet6);
  //     this.setSelect7(this.reportTableSelet7);
  //     this.setSelect8(this.reportTableSelet8);
  //     this.setSelect9(this.reportTableSelet9);
  //   } else {
  //     if (parseInt(this.reportType) === 12) {
  //       let have = this.reportTableSelet8.filter((ss:any) => {
  //         return ss.value === 'device_sn' || ss.value === 'device_number';
  //       });
  //       if (!have || have.length < 1) {
  //         this.showErrorMsg('设备SN号和设备编号中至少选一项！');
  //         return;
  //       }
  //     }
  //     this.activeName = 'third';
  //     this.tableResult = [];
  //     this.tableResult = this.tableResult.concat(this.reportTableSelet1);
  //     this.tableResult = this.tableResult.concat(this.reportTableSelet2);
  //     this.tableResult = this.tableResult.concat(this.reportTableSelet3);
  //     this.tableResult = this.tableResult.concat(this.reportTableSelet4);
  //     this.tableResult = this.tableResult.concat(this.reportTableSelet5);
  //     this.tableResult = this.tableResult.concat(this.reportTableSelet6);
  //     this.tableResult = this.tableResult.concat(this.reportTableSelet7);
  //     this.tableResult = this.tableResult.concat(this.reportTableSelet8);
  //     this.tableResult = this.tableResult.concat(this.reportTableSelet9);
  //     if (parseInt(this.reportType) !== 12) {
  //       this.tableResult = this.tableResult.concat(this.tableData);
  //     }

  //     // 订单维度 --- 响应时长，维修时长，修复时长。。。。。任务维度----任务编号，响应时长，维修时长，修复时长。。。。。设备维度  ----维修履历 不可拖拽，
  //   }
  // }
  private draggableChange() {}
  // private goBack() {
  //   this.$router.go(-1);
  // }
  private preStep() {
    if (this.activeName === 'third') {
      this.activeName = 'second';
    } else {
      this.tableResult = [];
      this.activeName = 'first';
    }
  }
  // private tempateName: any = '';
  private formtempateName: any = {
    name: ''
  }
  // private confirmStep() {
  //   let fiels: any = [];
  //   if (parseInt(this.reportType) !== 12) {
  //     this.tableResult.forEach((element: any) => {
  //       let field: any = {};
  //       if (element.isFirst === 1) {
  //         field.name = element.name;
  //         field.type = 2;
  //         field.start = element.startTime ? element.startTime.value : '';
  //         field.end = element.endTime ? element.endTime.value : '';
  //         field.suspend =
  //           element.parseTime && element.parseTime.value ? '1' : '0';
  //       } else {
  //         field.field = element.value;
  //         field.type = element.type;
  //       }
  //       fiels.push(field);
  //     });
  //   } else {
  //     let arrOrder:any = [];
  //     let list:any = [];
  //     let dlist:any = [];
  //     arrOrder = arrOrder.concat(this.reportTableSelet1);
  //     arrOrder = arrOrder.concat(this.reportTableSelet2);
  //     arrOrder = arrOrder.concat(this.reportTableSelet3);
  //     arrOrder = arrOrder.concat(this.reportTableSelet4);
  //     arrOrder = arrOrder.concat(this.reportTableSelet5);
  //     arrOrder = arrOrder.concat(this.reportTableSelet6);
  //     arrOrder = arrOrder.concat(this.reportTableSelet7);
  //     arrOrder = arrOrder.concat(this.reportTableSelet9);
  //     arrOrder.forEach((element: any) => {
  //       let field: any = {};
  //       field.field = element.value;
  //       field.type = element.type;
  //       list.push(field);
  //     });
  //     this.reportTableSelet8.forEach((element1: any) => {
  //       let field: any = {};
  //       field.field = element1.value;
  //       field.type = element1.type;
  //       dlist.push(field);
  //     });
  //     let ff:any = {};
  //     ff.order = list;
  //     ff.device = dlist;
  //     fiels = ff;
  //   }
  //   // 请输入2-20位由数字、字母、中文组成的名称
  //   this.$prompt('名称', '模版名称', {
  //     confirmButtonText: '确定',
  //     cancelButtonText: '取消',
  //     inputPlaceholder: '请输入模版名称',
  //     inputPattern: /^[A-Za-z0-9\u4e00-\u9fa5]{1,20}$/,
  //     inputErrorMessage: '请输入2-20位由数字、字母、中文组成的名称',
  //     inputValue: this.tempateName
  //   })
  //     .then(({ value }: any) => {
  //       this.setDiyOrderTemplate(value, fiels);
  //     })
  //     .catch(() => {});
  // }
  private setDiyOrderTemplate(name: string, fiels: any) {
    this.isCanClick = false;
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    if (this.editData && this.editData.id) {
      params.template_id = this.editData.id;
    }

    params.type = this.reportType;
    params.name = name;
    params.fields = JSON.stringify(fiels);
    setDiyOrderTemplate(params)
      .then((res) => {
        this.isCanClick = true;
        this.$router.back();
      })
      .catch((err) => {
        this.isCanClick = true;
        let msg = err.msg;
      });
  }
  private editData: any = {};
  private templateType = ''
  created() {
    this.templateEdit = parseInt(this.$route.query.templateEdit as string) !== 0;
    this.isNewModel = !this.templateEdit;
    if (this.templateEdit) {
      this.editData = JSON.parse(this.$route.query.data as string);
      this.setEdit();
    } else {
      let arrnew = this.dataTable[0].list.filter((fl: any) => {
        return fl.value === "order_num";
      })
      this.selectedItem = this.selectedItem.concat(arrnew)
    }
    this.templateType = parseInt(this.editData.type) === 11
      ? "订单维度"
      : parseInt(this.editData.type) === 12
        ? "设备维度"
        : parseInt(this.editData.type) === 17
          ? "任务维度" : '';
  }

  // private setEdit() {
  //   this.tempateName = this.editData.name;
  //   let fields:any = [];
  //   this.reportType = this.editData.type;
  //   switch (parseInt(this.editData.type)) {
  //     case 11:
  //       fields = this.editData.fields;
  //       this.activeName = 'first';
  //       this.isShowTime = true;
  //       break;
  //     case 12:
  //       fields = this.editData.fields.device;
  //       fields = fields.concat(this.editData.fields.order);
  //       this.activeName = 'second';
  //       this.isShowTime = false;
  //       break;
  //     case 17:
  //       fields = this.editData.fields;
  //       this.activeName = 'first';
  //       this.isShowTime = true;
  //       break;
  //   }
  //   let arr: any = [];
  //   fields.forEach((field: any) => {
  //     if (field.name) {
  //       let startItems = this.timeItemOptions.filter((time: any) => {
  //         return field.start === time.value;
  //       });
  //       let endItems = this.timeItemOptions.filter((time: any) => {
  //         return field.end === time.value;
  //       });
  //       let td: any = {};
  //       td.isFirst = 1;
  //       td.name = field.name;
  //       td.startTime = startItems[0];
  //       td.endTime = endItems[0];
  //       td.parseTime =
  //         parseInt(field.suspend) === 1 ? this.parseTimeOptions[0] : '';
  //       td.timeItemOptions = this.timeItemOptions;
  //       td.timeItemOptions2 = this.timeItemOptions;
  //       arr.push(td);
  //     } else {
  //       let arr1 = this.data1.filter((fl: any) => {
  //         return field.field === fl.value;
  //       });
  //       if (arr1 && arr1.length > 0) {
  //         this.reportTableSelet1 = this.reportTableSelet1.concat(arr1);
  //       }
  //       let arr2 = this.data2.filter((fl: any) => {
  //         return field.field === fl.value;
  //       });
  //       if (arr2 && arr2.length > 0) {
  //         this.reportTableSelet2 = this.reportTableSelet2.concat(arr2);
  //       }
  //       let arr3 = this.data3.filter((fl: any) => {
  //         return field.field === fl.value;
  //       });
  //       if (arr3 && arr3.length > 0) {
  //         this.reportTableSelet3 = this.reportTableSelet3.concat(arr3);
  //       }
  //       let arr4 = this.data4.filter((fl: any) => {
  //         return field.field === fl.value;
  //       });
  //       if (arr4 && arr4.length > 0) {
  //         this.reportTableSelet4 = this.reportTableSelet4.concat(arr4);
  //       }
  //       let arr5 = this.data5.filter((fl: any) => {
  //         return field.field === fl.value;
  //       });
  //       if (arr5 && arr5.length > 0) {
  //         this.reportTableSelet5 = this.reportTableSelet5.concat(arr5);
  //       }
  //       let arr6 = this.data6.filter((fl: any) => {
  //         return field.field === fl.value;
  //       });
  //       if (arr6 && arr6.length > 0) {
  //         this.reportTableSelet6 = this.reportTableSelet6.concat(arr6);
  //       }
  //       let arr7 = this.data7.filter((fl: any) => {
  //         return field.field === fl.value;
  //       });
  //       if (arr7 && arr7.length > 0) {
  //         this.reportTableSelet7 = this.reportTableSelet7.concat(arr7);
  //       }
  //       let arr8 = this.data8.filter((fl: any) => {
  //         return field.field === fl.value;
  //       });
  //       if (arr8 && arr8.length > 0) {
  //         this.reportTableSelet8 = this.reportTableSelet8.concat(arr8);
  //       }
  //       let arr9 = this.data9.filter((fl: any) => {
  //         return field.field === fl.value;
  //       });
  //       if (arr9 && arr9.length > 0) {
  //         this.reportTableSelet9 = this.reportTableSelet9.concat(arr9);
  //       }
  //     }
  //   });
  //   if (arr && arr.length > 0) {
  //     this.tableData = arr;
  //   }
  //   this.$nextTick(() => {
  //     if (this.activeName === 'second') {
  //       this.setSelect1(this.reportTableSelet1);
  //       this.setSelect2(this.reportTableSelet2);
  //       this.setSelect3(this.reportTableSelet3);
  //       this.setSelect4(this.reportTableSelet4);
  //       this.setSelect5(this.reportTableSelet5);
  //       this.setSelect6(this.reportTableSelet6);
  //       this.setSelect7(this.reportTableSelet7);
  //       this.setSelect8(this.reportTableSelet8);
  //       this.setSelect9(this.reportTableSelet9);
  //     }
  //   });
  // }
  private setSelect1(selectedData: any) {
    if (selectedData && selectedData.length > 0) {
      selectedData.forEach((element: any) => {
        (this.$refs.tableData1 as any).toggleRowSelection(element, true);
      });
    }
  }
  private setSelect2(selectedData: any) {
    if (selectedData && selectedData.length > 0) {
      selectedData.forEach((element: any) => {
        (this.$refs.tableData2 as any).toggleRowSelection(element, true);
      });
    }
  }
  private setSelect3(selectedData: any) {
    if (selectedData && selectedData.length > 0) {
      selectedData.forEach((element: any) => {
        (this.$refs.tableData3 as any).toggleRowSelection(element, true);
      });
    }
  }
  private setSelect4(selectedData: any) {
    if (selectedData && selectedData.length > 0) {
      selectedData.forEach((element: any) => {
        (this.$refs.tableData4 as any).toggleRowSelection(element, true);
      });
    }
  }
  private setSelect5(selectedData: any) {
    if (selectedData && selectedData.length > 0) {
      selectedData.forEach((element: any) => {
        (this.$refs.tableData5 as any).toggleRowSelection(element, true);
      });
    }
  }
  private setSelect6(selectedData: any) {
    if (selectedData && selectedData.length > 0) {
      selectedData.forEach((element: any) => {
        (this.$refs.tableData6 as any).toggleRowSelection(element, true);
      });
    }
  }
  private setSelect7(selectedData: any) {
    if (selectedData && selectedData.length > 0) {
      selectedData.forEach((element: any) => {
        (this.$refs.tableData7 as any).toggleRowSelection(element, true);
      });
    }
  }
  private setSelect8(selectedData: any) {
    if (selectedData && selectedData.length > 0) {
      selectedData.forEach((element: any) => {
        (this.$refs.tableData8 as any).toggleRowSelection(element, true);
      });
    }
  }
  private setSelect9(selectedData: any) {
    if (selectedData && selectedData.length > 0) {
      selectedData.forEach((element: any) => {
        (this.$refs.tableData9 as any).toggleRowSelection(element, true);
      });
    }
  }

  // 新版
  private active:number = 0
  private dataTable: any = [{
    title: '报修基本信息',
    list: [{
      name: '订单号',
      value: 'order_num',
      type: '1',
      class: 'customer'
    },
    {
      name: '工单号',
      value: 'work_order_num',
      type: '1',
      class: 'customer'
    },

    {
      name: '申请人',
      value: 'create_user_name',
      type: '1',
      class: 'customer'
    },
    {
      name: '报修部门',
      value: 'customer_dept',
      type: '1',
      class: 'customer'
    },
    {
      name: '报修部门编号',
      value: 'customer_dept_code',
      type: '1',
      class: 'customer'
    },
    {
      name: '报修部门(含上下级)',
      value: 'more_customer_dept_names',
      type: '1',
      class: 'customer'
    },

    {
      name: '报修公司',
      value: 'create_company_name',
      type: '1',
      class: 'customer'
    },
    {
      name: '客户',
      value: 'customer_company_name',
      type: '1',
      class: 'customer'
    },
    {
      name: '客户(含上下级)',
      value: 'parent_customer_company_name',
      type: '1',
      class: 'customer'
    },
    {
      name: '联系人',
      value: 'name',
      type: '1',
      class: 'customer'
    },
    {
      name: '手机号',
      value: 'mobile',
      type: '1',
      class: 'customer'
    },
    {
      name: '联系电话',
      value: 'phone_num',
      type: '1',
      class: 'customer'
    },
    {
      name: '地址',
      value: 'address',
      type: '1',
      class: 'customer'
    },
    {
      name: '任务描述',
      value: 'trouble_describle',
      type: '1',
      class: 'customer'
    },
    {
      name: '服务部门',
      value: 'servicer_dept',
      type: '1',
      class: 'customer'
    },
    {
      name: '客户预约时间',
      value: 'customer_appointment_time',
      type: '1',
      class: 'customer'
    },
    {
      name: '报修sn号',
      value: 'order_device_sn',
      type: '1',
      class: 'customer'
    }, {
      name: '自定义字段1',
      value: 'diy_one_content',
      type: '1',
      class: 'customer'
    }, {
      name: '自定义字段2',
      value: 'diy_two_content',
      type: '1',
      class: 'customer'
    }]
  }, {
    title: '订单基本信息',
    list: [{
      name: '服务方',
      value: 'servicer_company',
      type: '1',
      class: 'order'
    }, {
      name: '合作服务方',
      value: 'cooperate_service_company_name',
      type: '1',
      class: 'order'
    }, {
      name: '转入方',
      value: 'transfer_in_company_name',
      type: '1',
      class: 'order'
    },
    {
      name: '订单创建时间',
      value: 'add_time',
      type: '1',
      class: 'order'
    },
    {
      name: '订单查看时间',
      value: 'view_time',
      type: '1',
      class: 'order'
    },
    {
      name: '订单处理时间',
      value: 'deal_time',
      type: '1',
      class: 'order'
    },
    {
      name: '订单完成时间',
      value: 'finish_time',
      type: '1',
      class: 'order'
    },
    {
      name: '维修单状态',
      value: 'order_service_state_name',
      type: '1',
      class: 'order'
    },
    {
      name: '订单关闭时间',
      value: 'close_time',
      type: '1',
      class: 'order'
    },
    {
      name: '预约时间',
      value: 'appointment_time',
      type: '1',
      class: 'order'
    },
    {
      name: '订单类型',
      value: 'order_type',
      type: '1',
      class: 'order'
    },
    // {
    //   name: '订单视频',
    //   value: 'rtc_video',
    //   type: '1',
    //   class: 'order'
    // },
    {
      name: '报修方/公司、部门评分',
      value: 'repair_dept_com_evaluate_score',
      type: '1',
      class: 'order'
    },
    {
      name: '报修方/公司、部门评价内容',
      value: 'repair_dept_com_evaluate_detail',
      type: '1',
      class: 'order'
    },
    {
      name: '服务方/公司、部门评分',
      value: 'service_dept_com_evaluate_score',
      type: '1',
      class: 'order'
    },
    {
      name: '服务方/公司、部门评价内容',
      value: 'service_dept_com_evaluate_detail',
      type: '1',
      class: 'order'
    },
    {
      name: '最终/公司、部门评分',
      value: 'final_dept_com_evaluate_score',
      type: '1',
      class: 'order'
    },
    {
      name: '最终/公司、部门评价内容',
      value: 'final_dept_com_evaluate_detail',
      type: '1',
      class: 'order'
    },
    {
      name: '报修方/处理人评分',
      value: 'task_evaluate_score',
      type: '1',
      class: 'order'
    },
    {
      name: '报修方/评价内容',
      value: 'task_evaluate_detail',
      type: '1',
      class: 'order'
    },
    {
      name: '服务方/处理人评分',
      value: 'task_service_evaluate_score',
      type: '1',
      class: 'order'
    },
    {
      name: '服务方/评价内容',
      value: 'task_service_evaluate_detail',
      type: '1',
      class: 'order'
    },
    {
      name: '最终/处理人评分',
      value: 'task_final_evaluate_score',
      type: '1',
      class: 'order'
    },
    {
      name: '最终/评价内容',
      value: 'task_final_evaluate_detail',
      type: '1',
      class: 'order'
    },
    {
      name: '是否原厂保修',
      value: 'order_warranty',
      type: '1',
      class: 'order'
    }]
  }, {
    title: '任务基本信息',
    list: [{
      name: '任务编号',
      value: 'task_num',
      type: '1',
      class: 'task'
    },
    {
      name: '派单人',
      value: 'task_assign_user_name',
      type: '1',
      class: 'task'
    },
    {
      name: '处理人',
      value: 'task_user_name',
      type: '1',
      class: 'task'
    },
    {
      name: '任务类型',
      value: 'task_deal_type',
      type: '1',
      class: 'task'
    },
    {
      name: '任务状态',
      value: 'task_state',
      type: '1',
      class: 'task'
    },
    {
      name: '任务指派时间',
      value: 'task_assign_time',
      type: '1',
      class: 'task'
    },
    {
      name: '任务查看时间',
      value: 'task_view_time',
      type: '1',
      class: 'task'
    },
    {
      name: '任务处理时间',
      value: 'task_deal_time',
      type: '1',
      class: 'task'
    },
    {
      name: '任务完成时间',
      value: 'task_finish_time',
      type: '1',
      class: 'task'
    },
    {
      name: '任务上报时间',
      value: 'task_appear_time',
      type: '1',
      class: 'task'
    },
    {
      name: '任务关闭时间',
      value: 'task_close_time',
      type: '1',
      class: 'task'
    },
    {
      name: '维修小结',
      value: 'task_fix_summary',
      type: '1',
      class: 'task'
    },
    {
      name: '任务暂停时长',
      value: 'task_suspend_time',
      type: '1',
      class: 'task'
    },
    {
      name: '任务暂停备注',
      value: 'task_suspend_remark',
      type: '1',
      class: 'task'
    },
    {
      name: '任务部门',
      value: 'task_dept_name',
      type: '1',
      class: 'task'
    },
    {
      name: '报修方/自定义评价',
      value: 'repair_diy_evaluate',
      type: '1'
    },
    {
      name: '服务方/自定义评价',
      value: 'service_diy_evaluate',
      type: '1'
    }
    ]
  }, {
    title: '上门维修',
    list: [{
      name: '上门预约时间',
      value: 'task_visit_time',
      type: '1',
      class: 'come'
    },
    {
      name: '签到时间',
      value: 'task_checkin_time',
      type: '1',
      class: 'come'
    },
    {
      name: '签到地点',
      value: 'checkin_addr',
      type: '1',
      class: 'come'
    },
    {
      name: '完成地点',
      value: 'finish_addr',
      type: '1',
      class: 'come'
    }  
  ]
  }, {
    title: '寄修',
    list: [{
      name: '报修方寄出时间',
      value: 'task_send_off_time',
      type: '1',
      class: 'send'
    },
    {
      name: '服务方收货时间',
      value: 'task_send_receive_time',
      type: '1',
      class: 'send'
    }]
  }, {
    title: '订单其他信息',
    list: [{
      name: '故障现象',
      value: 'p_fault_phenomenon_name',
      type: '1',
      class: 'other'
    },
    {
      name: '故障类型',
      value: 'p_fault_type_name',
      type: '1',
      class: 'other'
    },
    {
      name: '产品品牌',
      value: 'product_brand',
      type: '1',
      class: 'other'
    },
    {
      name: '产品类型',
      value: 'product_product',
      type: '1',
      class: 'other'
    },
    {
      name: '产品型号',
      value: 'product_model',
      type: '1',
      class: 'other'
    },
    {
      name: '产品数量',
      value: 'product_amount',
      type: '1',
      class: 'other'
    },
    {
      name: '自定义标签',
      value: 'tags_name',
      type: '1',
      class: 'other'
    },
    {
      name: '备注',
      value: 'all_remark',
      type: '1',
      class: 'other'
    },
    {
      name: '催单次数',
      value: 'push_reminder_amount',
      type: '1',
      class: 'other'
    },
    {
      name: '总费用',
      value: 'total_price',
      type: '1',
      class: 'other'
    },
    {
      name: '备件总费用',
      value: 'parts_amount',
      type: '1',
      class: 'other'
    },
    {
      name: '其他总费用',
      value: 'price_amount',
      type: '1',
      class: 'other'
    },
    {
      name: '其他费用明细',
      value: 'price_amount_detail',
      type: '1',
      class: 'other'
    },
    {
      name: '实际收费',
      value: 'real_price',
      type: '1',
      class: 'other'
    },
    {
      name: '结算费用',
      value: 'order_service_settle',
      type: '1',
      class: 'other'
    },
    {
      name: '工时明细',
      value: 'work_time_detail',
      type: '1',
      class: 'other'
    },
    {
      name: '订单状态',
      value: 'order_service_state',
      type: '1',
      class: 'other'
    },
    {
      name: '订单审核信息',
      value: 'order_check',
      type: '1',
      class: 'other'
    },
    {
      name: '订单关闭原因',
      value: 'order_close_remark',
      type: '1',
      class: 'other'
    },
    {
      name: '订单拒绝验收',
      value: 'order_refuse_complete',
      type: '1',
      class: 'other'
    },
    {
      name: '回访信息',
      value: 'return_visit',
      type: '1',
      class: 'other'
    },
    {
      name: '订单投诉',
      value: 'bbs_complaint',
      type: '1',
      class: 'other'
    },
    {
      name: '订单留言',
      value: 'bbs_ordinary',
      type: '1',
      class: 'other'
    },
    {
      name: '正常完成任务数',
      value: 'normal_task_count',
      type: '1',
      class: 'other'
    },
    {
      name: '订单超时',
      value: 'order_timeout',
      type: '1'
    },
    {
      name: '订单加急',
      value: 'expedited',
      type: '1'
    }
    ]
  }, {
    title: '巡检计划',
    list: [{
      name: '巡检事件',
      value: 'check_event',
      type: '1',
      class: 'polling'
    },
    {
      name: '检查项',
      value: 'event_list',
      type: '1',
      class: 'polling'
    },
    {
      name: '计划名称',
      value: 'project_name',
      type: '1',
      class: 'polling'
    },
    {
      name: '计划开始时间',
      value: 'project_start_time',
      type: '1',
      class: 'polling'
    },
    {
      name: '计划结束时间',
      value: 'project_end_time',
      type: '1',
      class: 'polling'
    },
    {
      name: '提前生成订单时间',
      value: 'ahead_inform_time',
      type: '1',
      class: 'polling'
    },
    {
      name: '执行规则',
      value: 'implement_project',
      type: '1',
      class: 'polling'
    },
    {
      name: '重复规则',
      value: 'repeat_type',
      type: '1',
      class: 'polling'
    }]
  }, {
    title: '安装交付',
    list: [{
      name: '安装订单来源',
      value: 'install_source_name',
      type: '1',
      class: 'install'
    }, {
      name: '安装原始单号',
      value: 'order_original_num',
      type: '1',
      class: 'install'
    }, {
      name: '安装预约时间',
      value: 'original_appointment_time',
      type: '1',
      class: 'install'
    }]
  }, {
    title: '设备相关信息',
    list: [{
      name: '设备名称',
      value: 'device_name',
      type: '1',
      class: 'device'
    },
    {
      name: '设备编号',
      value: 'device_number',
      type: '1',
      class: 'device'
    },
    {
      name: '设备SN号',
      value: 'device_sn',
      type: '1',
      class: 'device'
    },
    {
      name: '设备品牌',
      value: 'device_brand',
      type: '1',
      class: 'device'
    },
    {
      name: '设备类型',
      value: 'device_product',
      type: '1',
      class: 'device'
    },
    {
      name: '设备型号',
      value: 'device_model',
      type: '1',
      class: 'device'
    },
    {
      name: '设备购买时间',
      value: 'device_buy_time',
      type: '1',
      class: 'device'
    },
    {
      name: '设备描述',
      value: 'device_describe',
      type: '1',
      class: 'device'
    },
    {
      name: '设备地址',
      value: 'device_address',
      type: '1',
      class: 'device'
    },
    {
      name: '设备厂商名称',
      value: 'manufacturer_name',
      type: '1',
      class: 'device'
    },
    {
      name: '设备厂商电话',
      value: 'manufacturer_phone',
      type: '1',
      class: 'device'
    },
    {
      name: '备件名称',
      value: 'parts_name',
      type: '1',
      class: 'device'
    },
    {
      name: '备件型号',
      value: 'parts_model_name',
      type: '1',
      class: 'device'
    },
    {
      name: '备件编号',
      value: 'parts_serial_number',
      type: '1',
      class: 'device'
    },
    {
      name: '备件规格',
      value: 'parts_specification',
      type: '1',
      class: 'device'
    },
    {
      name: '备件数量',
      value: 'parts_amount_count',
      type: '1',
      class: 'device'
    },
    {
      name: '备件公司成本价',
      value: 'parts_company_price',
      type: '1',
      class: 'device'
    },
    {
      name: '备件个人成本价',
      value: 'parts_person_price',
      type: '1',
      class: 'device'
    },
    {
      name: '备件单价',
      value: 'parts_unit_price',
      type: '1',
      class: 'device'
    },
    {
      name: '备件单价实际原价',
      value: 'parts_unit_price_original',
      type: '1',
      class: 'device'
    },
    {
      name: '备件总费用实际原价',
      value: 'parts_amount_original',
      type: '1',
      class: 'device'
    }]
  }, ]
  private selectedMenu: any = [];
  private selectedItem: any = [];
  private checkAll = false;
  // private isIndeterminate: any = null;

  @Watch('reportType', { deep: true, immediate: true })
  reportTypeChange() {
    switch (parseInt(this.reportType)) {
      case 11:
        this.isShowTime = true;
        // if (this.isNewModel) {
        //   this.selectedItem = []
        //   let arrInitCustomer = this.dataTable[0].list.filter((fl: any) => {
        //     return fl.value === "order_num" || fl.value === "create_user_name" || fl.value === "mobile" || fl.value === "address" || fl.value === "servicer_dept" || fl.value === "trouble_describle";
        //   })
        //   let arrInitOrder = this.dataTable[1].list.filter((fl: any) => {
        //     return fl.value === "order_service_state_name" || fl.value === "add_time" || fl.value === "finish_time";
        //   })
        //   let arrInitTask = this.dataTable[2].list.filter((fl: any) => {
        //     return fl.value === "task_assign_user_name" || fl.value === "task_user_name" || fl.value === "task_assign_time" || fl.value === "task_finish_time" || fl.value === "task_fix_summary";
        //   })
        //   let arrInitCome = this.dataTable[3].list.filter((fl: any) => {
        //     return fl.value === "checkin_addr";
        //   })
        //   let arrInitOther = this.dataTable[5].list.filter((fl: any) => {
        //     return fl.value === "p_fault_phenomenon_name" || fl.value === "p_fault_type_name" || fl.value === "total_price";
        //   })
        //   let arrInitDevice = this.dataTable[8].list.filter((fl: any) => {
        //     return fl.value === "parts_name" || fl.value === "parts_amount_count";
        //   })

        //   this.selectedItem = this.selectedItem.concat(arrInitCustomer)
        //   this.selectedItem = this.selectedItem.concat(arrInitOrder)
        //   this.selectedItem = this.selectedItem.concat(arrInitTask)
        //   this.selectedItem = this.selectedItem.concat(arrInitCome)
        //   this.selectedItem = this.selectedItem.concat(arrInitOther)
        //   this.selectedItem = this.selectedItem.concat(arrInitDevice)
        // }
        break;
      case 17:
        this.isShowTime = true;
        // if (this.isNewModel) {
        //   this.selectedItem = []
        //   let arrInitCustomer = this.dataTable[0].list.filter((fl: any) => {
        //     return fl.value === "order_num" || fl.value === "create_user_name" || fl.value === "mobile" || fl.value === "parent_customer_company_name" || fl.value === "trouble_describle";
        //   })
        //   let arrInitOrder = this.dataTable[1].list.filter((fl: any) => {
        //     return fl.value === "add_time";
        //   })
        //   let arrInitTask = this.dataTable[2].list.filter((fl: any) => {
        //     return fl.value === "task_assign_user_name" || fl.value === "task_user_name" || fl.value === "task_assign_time" || fl.value === "task_view_time" || fl.value === "task_deal_time" || fl.value === "task_finish_time" || fl.value === "task_fix_summary";
        //   })
        //   let arrInitCome = this.dataTable[3].list.filter((fl: any) => {
        //     return fl.value === "checkin_addr" || fl.value === "task_checkin_time";
        //   })
        //   let arrInitOther = this.dataTable[5].list.filter((fl: any) => {
        //     return fl.value === "order_service_state";
        //   })
        //   this.selectedItem = this.selectedItem.concat(arrInitCustomer)
        //   this.selectedItem = this.selectedItem.concat(arrInitOrder)
        //   this.selectedItem = this.selectedItem.concat(arrInitTask)
        //   this.selectedItem = this.selectedItem.concat(arrInitCome)
        //   this.selectedItem = this.selectedItem.concat(arrInitOther)
        // }
        break;
      case 12:
        this.isShowTime = false;
        // if (this.isNewModel) {
        //   this.selectedItem = []
        //   let arrInitCustomer = this.dataTable[0].list.filter((fl: any) => {
        //     return fl.value === "order_num" || fl.value === "create_user_name" || fl.value === "mobile" || fl.value === "trouble_describle";
        //   })
        //   let arrInitOrder = this.dataTable[1].list.filter((fl: any) => {
        //     return fl.value === "add_time" || fl.value === "finish_time";
        //   })
        //   let arrInitTask = this.dataTable[2].list.filter((fl: any) => {
        //     return fl.value === "task_user_name" || fl.value === "task_fix_summary";
        //   })
        //   let arrInitDevice = this.dataTable[8].list.filter((fl: any) => {
        //     return fl.value === "device_name" || fl.value === "device_product" || fl.value === "device_model" || fl.value === "device_sn" || fl.value === "device_number" || fl.value === "device_address" || fl.value === "parts_name" || fl.value === "parts_amount_count" || fl.value === "parts_model_name" || fl.value === "parts_specification";
        //   })

        //   this.selectedItem = this.selectedItem.concat(arrInitCustomer)
        //   this.selectedItem = this.selectedItem.concat(arrInitOrder)
        //   this.selectedItem = this.selectedItem.concat(arrInitTask)
        //   this.selectedItem = this.selectedItem.concat(arrInitDevice)
        // }
        break;
    }
  }

  private setEdit() {
    this.formtempateName.name = this.editData.name;
    let fields:any = [];
    this.reportType = this.editData.type;
    switch (parseInt(this.editData.type)) {
      case 11:
      case 17:
        fields = this.editData.fields;
        break;
      case 12:
        fields = this.editData.fields.device;
        fields = fields.concat(this.editData.fields.order);
        break;
    }

    let arr: any = [];
    let arrCustomer: any = []
    let arrOrder: any = []
    let arrTask: any = []
    let arrCome: any = []
    let arrSend: any = []
    let arrOther: any = []
    let arrDevice: any = []
    let arrPolling: any = []
    let arrInstall: any = []
    fields.forEach((field: any) => {
      if (field.name) {
        let startItems = this.timeItemOptions.filter((time: any) => {
          return field.start === time.value;
        });
        let endItems = this.timeItemOptions.filter((time: any) => {
          return field.end === time.value;
        });
        let td: any = {};
        td.isFirst = 1;
        td.name = field.name;
        td.startTime = startItems[0];
        td.endTime = endItems[0];
        td.parseTime =
          parseInt(field.suspend) === 1 ? this.parseTimeOptions[0] : '';
        td.timeItemOptions = this.timeItemOptions;
        td.timeItemOptions2 = this.timeItemOptions;
        arr.push(td);
      } else {
        for (let k = 0; k < this.dataTable.length; k++) {
          let arrAll = this.dataTable[k].list.filter((fl: any) => {
            return field.field === fl.value;
          });
          this.selectedItem = this.selectedItem.concat(arrAll)
        }
      }
    });

    // arrCustomer = this.selectedItem.filter((fl: any) => {
    //   return fl.class === 'customer';
    // });
    // arrOrder = this.selectedItem.filter((fl: any) => {
    //   return fl.class === 'order';
    // });
    // arrTask = this.selectedItem.filter((fl: any) => {
    //   return fl.class === 'task';
    // });
    // arrCome = this.selectedItem.filter((fl: any) => {
    //   return fl.class === 'come';
    // });
    // arrSend = this.selectedItem.filter((fl: any) => {
    //   return fl.class === 'send';
    // });
    // arrOther = this.selectedItem.filter((fl: any) => {
    //   return fl.class === 'other';
    // });
    // arrPolling = this.selectedItem.filter((fl: any) => {
    //   return fl.class === 'polling';
    // });
    // arrInstall = this.selectedItem.filter((fl: any) => {
    //   return fl.class === 'install';
    // });
    // arrDevice = this.selectedItem.filter((fl: any) => {
    //   return fl.class === 'device';
    // });

    // if (this.dataTable[0].list.length === arrCustomer.length) {
    //   this.selectedMenu = this.selectedMenu.concat(this.dataTable[0])
    // }
    // if (this.dataTable[1].list.length === arrOrder.length) {
    //   this.selectedMenu = this.selectedMenu.concat(this.dataTable[1])
    // }
    // if (this.dataTable[2].list.length === arrTask.length) {
    //   this.selectedMenu = this.selectedMenu.concat(this.dataTable[2])
    // }
    // if (this.dataTable[3].list.length === arrCome.length) {
    //   this.selectedMenu = this.selectedMenu.concat(this.dataTable[3])
    // }
    // if (this.dataTable[4].list.length === arrSend.length) {
    //   this.selectedMenu = this.selectedMenu.concat(this.dataTable[4])
    // }
    // if (this.dataTable[5].list.length === arrOther.length) {
    //   this.selectedMenu = this.selectedMenu.concat(this.dataTable[5])
    // }
    // if (this.dataTable[6].list.length === arrPolling.length) {
    //   this.selectedMenu = this.selectedMenu.concat(this.dataTable[6])
    // }
    // if (this.dataTable[7].list.length === arrInstall.length) {
    //   this.selectedMenu = this.selectedMenu.concat(this.dataTable[7])
    // }
    // if (this.dataTable[8].list.length === arrDevice.length) {
    //   this.selectedMenu = this.selectedMenu.concat(this.dataTable[8])
    // }

    // let _len = this.dataTable.length;
    // this.isIndeterminate = this.selectedMenu.length > 0 && this.selectedMenu.length < _len;
    // this.checkAll = _len === this.selectedMenu.length;

    if (arr && arr.length > 0) {
      this.tableData = arr;
    }
  }
  private createModel() {
    if (!this.reportType) {
      this.showErrorMsg('请选择报表类型');
      return;
    }
    if (parseInt(this.reportType) === 12) { // 设备报表
      let have = this.selectedItem.filter((ss:any) => {
        return ss.value === 'device_sn' || ss.value === 'device_number';
      });
      if (!have || have.length < 1) {
        this.showErrorMsg('设备SN号和设备编号中至少选一项！');
        return;
      }
    }
    // 订单维度 --- 响应时长，维修时长，修复时长。。。。。任务维度----任务编号，响应时长，维修时长，修复时长。。。。。设备维度  ----维修履历 不可拖拽，
    this.active = 1
  }

  // private selectedItemChange(row: any) {自测还有点问题，以后放开再说吧
  //   let arrCustomer = this.selectedItem.filter((fl: any) => {
  //     return fl.class === "customer";
  //   })
  //   let arrOrder = this.selectedItem.filter((fl: any) => {
  //     return fl.class === "order";
  //   })
  //   let arrTask = this.selectedItem.filter((fl: any) => {
  //     return fl.class === "task";
  //   })
  //   let arrCome = this.selectedItem.filter((fl: any) => {
  //     return fl.class === "come";
  //   })
  //   let arrSend = this.selectedItem.filter((fl: any) => {
  //     return fl.class === "send";
  //   })
  //   let arrOther = this.selectedItem.filter((fl: any) => {
  //     return fl.class === "other";
  //   })
  //   let arrPolling = this.selectedItem.filter((fl: any) => {
  //     return fl.class === "polling";
  //   })
  //   let arrInstall = this.selectedItem.filter((fl: any) => {
  //     return fl.class === "install";
  //   })
  //   let arrDevice = this.selectedItem.filter((fl: any) => {
  //     return fl.class === "device";
  //   })

  //   let isItem = this.selectedItem.filter((fl: any) => {
  //     return fl.value === row.value;
  //   })

  //   if (isItem && isItem.length > 0) {
  //     if (this.dataTable[0].list.length === arrCustomer.length) {
  //       this.selectedMenu = this.selectedMenu.concat(this.dataTable[0])
  //     }
  //     if (this.dataTable[1].list.length === arrOrder.length) {
  //       this.selectedMenu = this.selectedMenu.concat(this.dataTable[1])
  //     }
  //     if (this.dataTable[2].list.length === arrTask.length) {
  //       this.selectedMenu = this.selectedMenu.concat(this.dataTable[2])
  //     }
  //     if (this.dataTable[3].list.length === arrCome.length) {
  //       this.selectedMenu = this.selectedMenu.concat(this.dataTable[3])
  //     }
  //     if (this.dataTable[4].list.length === arrSend.length) {
  //       this.selectedMenu = this.selectedMenu.concat(this.dataTable[4])
  //     }
  //     if (this.dataTable[5].list.length === arrOther.length) {
  //       this.selectedMenu = this.selectedMenu.concat(this.dataTable[5])
  //     }
  //     if (this.dataTable[6].list.length === arrPolling.length) {
  //       this.selectedMenu = this.selectedMenu.concat(this.dataTable[6])
  //     }
  //     if (this.dataTable[7].list.length === arrInstall.length) {
  //       this.selectedMenu = this.selectedMenu.concat(this.dataTable[7])
  //     }
  //     if (this.dataTable[8].list.length === arrDevice.length) {
  //       this.selectedMenu = this.selectedMenu.concat(this.dataTable[8])
  //     }
  //   } else {
  //     let qu: any = {};
  //     for (let i = 0; i < this.selectedMenu.length; i++) {
  //       if (!this.selectedMenu[i].list.every((ele: any) => ele.value !== row.value)) {
  //         qu = this.selectedMenu[i]
  //       }
  //     }
  //     this.selectedMenu = this.selectedMenu.filter((fl: any) => {
  //       return fl.title !== qu.title;
  //     })
  //   }
  // }
  // private selectedMenuChange(row: any) {
  //   let isCheck = this.selectedMenu.filter((fl: any) => {
  //     return fl.title === row.title;
  //   })
  //   if (isCheck && isCheck.length > 0) {
  //     this.selectedItem = this.selectedItem.concat(row.list)
  //   } else {
  //     for (let i = 0; i < row.list.length; i++) {
  //       this.selectedItem = this.selectedItem.filter((fl: any) => {
  //         return fl.value !== row.list[i].value;
  //       })
  //     }
  //   }

  //   let horder = this.selectedItem.filter((fl: any) => {
  //     return fl.value === "order_num";
  //   })
  //   let arrOrderNum = this.dataTable[0].list.filter((fl: any) => {
  //     return fl.value === "order_num";
  //   })
  //   if (!horder || horder.length === 0) {
  //     this.selectedItem = arrOrderNum.concat(this.selectedItem)
  //   }

  //   // let _len = this.dataTable.length;
  //   // this.isIndeterminate = this.selectedMenu.length > 0 && this.selectedMenu.length < _len;
  //   // this.checkAll = _len === this.selectedMenu.length;
  // }
  // private CheckAllChange(val: any) {
  //   if (val) { // 全选
  //     this.selectedMenu = []
  //     for (let k = 0; k < this.dataTable.length; k++) {
  //       this.selectedMenu = this.selectedMenu.concat(this.dataTable[k])
  //     }
  //     this.selectedItem = [];
  //     for (let m = 0; m < this.selectedMenu.length; m++) {
  //       this.selectedItem = this.selectedItem.concat(this.selectedMenu[m].list)
  //     }
  //   } else {
  //     this.selectedMenu = []
  //     this.selectedItem = []
  //     let arrnew = this.dataTable[0].list.filter((fl: any) => {
  //       return fl.value === "order_num";
  //     })
  //     this.selectedItem = this.selectedItem.concat(arrnew)
  //   }
  //   // this.isIndeterminate = false
  // }

  private next() {
    if (this.active === 0) {
      this.tableResult = [];
      this.tableResult = this.tableResult.concat(this.selectedItem)
      if (parseInt(this.reportType) !== 12) {
        this.tableResult = this.tableResult.concat(this.tableData);
      }
      this.createModel()
    } else if (this.active === 1) {
      if (parseInt(this.reportType) !== 12) {
        this.tableResult = [];
        this.tableResult = this.tableResult.concat(this.selectedItem)
        this.tableResult = this.tableResult.concat(this.tableData);
      }
      this.active = 2
    } else if (this.active === 2) {
      this.active = 3
    }
  }
  private prev() {
    if (this.active === 1) {
      this.active = 0
    } else if (this.active === 2) {
      this.active = 1
    } else if (this.active === 3) {
      this.active = 2
    }
  }
  private isCanClick=true;
  private confirmStep() {
    if (!this.isCanClick) {
      this.showErrorMsg('请勿连续点击');
      return
    }
    // 验证名字
    if (!this.formtempateName.name) {
      this.showErrorMsg('请输入报表名称');
      return;
    }

    let fiels: any = [];
    if (parseInt(this.reportType) !== 12) {
      this.tableResult.forEach((element: any) => {
        let field: any = {};
        if (element.isFirst === 1) {
          field.name = element.name;
          field.type = 2;
          field.start = element.startTime ? element.startTime.value : '';
          field.end = element.endTime ? element.endTime.value : '';
          field.suspend =
            element.parseTime && element.parseTime.value ? '1' : '0';
        } else {
          field.field = element.value;
          field.type = element.type;
        }
        fiels.push(field);
      });
    } else {
      let arrOrder:any = [];
      let arrDevece:any = [];
      let list:any = [];
      let dlist:any = [];

      // 非设备维度
      if (this.tableResult.length > 0) {
        arrOrder = this.tableResult.filter((fl: any) => {
          return fl.class !== 'device';
        });
      }
      arrOrder.forEach((element: any) => {
        let field: any = {};
        field.field = element.value;
        field.type = element.type;
        list.push(field);
      });

      // 设备维度
      if (this.tableResult.length > 0) {
        arrDevece = this.tableResult.filter((fl: any) => {
          return fl.class === 'device';
        });
      }
      arrDevece.forEach((element1: any) => {
        let field: any = {};
        field.field = element1.value;
        field.type = element1.type;
        dlist.push(field);
      });

      let ff:any = {};
      ff.order = list;
      ff.device = dlist;
      fiels = ff;
    }

    (this.$refs.formtempate as any).validate((valid: any) => {
      if (valid) {
        this.setDiyOrderTemplate(this.formtempateName.name, fiels);
      } else {
        return false;
      }
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
